import React from 'react';

function TermsConditionsContainer(props) {
  return (
    <div className = 'mr-5 ml-5'>
      <br/> <br/>
      <br/> <br/>
      <br/> <br/>
     <h1> Terms and Conditions </h1>

<br/> <br/>Last updated: (25/06/2021)


<br/> <br/>
Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the http://www.camaxonline.com website and the CA MAX Mobile App (the "Service") operated by Microsys & Equipments ("us", "we", or "our").

<br/> <br/>
Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.

<br/> <br/>
By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.<br/> <br/>

<strong>Purchases</strong>
<br/> 
If you wish to purchase any product or service made available through the Service ("Purchase"), you may be asked to supply certain information relevant to your Purchase including, without limitation.
<br/> <br/> 
<strong>Subscriptions</strong><br/> 
Some parts of the Service are billed on a subscription/AMC basis ("Subscription(s)"). You will be billed in as per Annual System
<br/> <br/> 
<strong>Links To Other Web Sites</strong>
<br/> 
Our Service does not use links to third-party web sites or services that are not owned or controlled by our Company.
<br/> 
Microsys & Equipments has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Microsys & Equipments shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
<br/> <br/> 
<strong>Changes</strong>
<br/> 
We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
<br/> <br/> 
<strong>Contact Us</strong>
<br/> 
If you have any questions about these Terms, please contact us.

<br/> 

Microsys & Equipments
DSS 147 P,
Sector 11,
Panchkula, Haryana 134109
India
<br/> 

If you have questions or comments about this notice, you may email us at microsysindia63@gmail.com


<br/> <br/> <br/> <br/> <br/> 

    </div>
  );
}

export default TermsConditionsContainer;